import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'category'
})
export class CategoryPipe implements PipeTransform {

  transform(valueArray: any[], searchTerm: string): any {
    if(searchTerm){
      return valueArray.filter(single=>single.name.toLowerCase().includes(searchTerm.toLowerCase()));
    } else {
      return valueArray;
    }
  }

}
